import baseapi from "../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const CampaignListAPI = async (setCampaignList) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get('api/sales/campaigns');

        //console.log("Data got successfully", response.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setCampaignList(response.data.datalist.data);
        //setLoading(false);
    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

export const saveNewLeadDataAPI = async (params, setLoading, resetUserForm) =>
{
    setLoading(true);

    try 
    {
        const response = await baseapi.post('api/sales/lead/add', params);

        //console.log("Data got successfully", response);
        
        if(response.data.code == 200)
        {
            successMesg("Lead has been updated successfully");

            resetUserForm();
        }
        else
        {
            errorMesg("Lead has not been added. Please try again!!!");
        }
        
        setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
        errorMesg("Lead has not been added. Please try again!!!");
    }
}

export const getProfileInfoAPI = async (setName, setEmail, setContact, setLocation, setStage, setDisposition, setSubDisposition, setOtherEmail, setOtherContact, setProgram, setInstitute, setSource, setCreatedDate, setLastUpdated, setRemarks, setPipeline, leadid) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get('api/sales/lead/profile/' + leadid);

        //console.log("Data got successfully", response.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        //setCampaignList(response.data.data.data);
        //setLoading(false);

        setName(response.data.profiledata.name);
        setEmail(response.data.profiledata.email);
        setContact(response.data.profiledata.contact);
        setLocation(response.data.profiledata.location);
        setStage(response.data.profiledata.stagename);
        setDisposition(response.data.profiledata.dispositionname);
        setSubDisposition(response.data.profiledata.subdispositionname);
        setOtherEmail(response.data.profiledata.other_email);
        setOtherContact(response.data.profiledata.alternate_contact);
        setProgram(response.data.profiledata.program);
        setInstitute(response.data.profiledata.institute);
        setSource(response.data.profiledata.source);
        setCreatedDate(response.data.profiledata.created_at);
        setLastUpdated(response.data.profiledata.lastupdated);
        setRemarks(response.data.remarks);
        setPipeline(response.data.stages);
    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}





